import { store } from '../../../../store';
import { useSelector } from 'react-redux';

/**
 *  @description LOW LEVEL API DO NOT USE
 *  @returns {boolean}
 */
export const isNewOrderTarget = () => {
    try {
        return !!JSON.parse(localStorage.user_id).factoryData
            .isNewOrderTarget;
    } catch (e) {
        return false;
    }
};

/**
 *  @description LOW LEVEL API DO NOT USE
 *  @returns {boolean}
 */
export const isNewOrderTargetEnabled = () => {
    try {
        const state = store.getState();
        return (
            state.settings.isNewOrderTarget
        );
    } catch (e) {
        return false;
    }
};

/** @returns {boolean}  */
export const useNewOrderTarget = () =>
    useSelector(({ settings }) => settings.isNewOrderTarget);